import React from "react";
import PropTypes from "prop-types";
import { StyleSheet, css } from "aphrodite";
import { Checkbox, FlatButton } from "material-ui";
import { commitMutation, graphql } from "react-relay";
import environment from "../../relay/environment";

import OurismanTravelTheme from "../../ourismanTravelTheme";

export default class TaskListItem extends React.Component {
  static propTypes = {
    task: PropTypes.shape().isRequired
  };

  completeTask = (e, checked) => {
    const {
      task: { id: taskId }
    } = this.props;

    commitMutation(environment, {
      mutation: graphql`
        mutation TaskListItem_CompleteTask_Mutation($input: TaskActionInput!) {
          taskAction(input: $input) {
            task {
              completed
              voided
              history {
                name
                action
                timestamp
              }
              trip {
                id
                welcomeHome
              }
            }
          }
        }
      `,
      variables: { input: { taskId, action: "complete", value: checked } },
      onError: err => alert(err)
    });
  };

  voidTask = () => {
    const {
      task: { id: taskId }
    } = this.props;

    commitMutation(environment, {
      mutation: graphql`
        mutation TaskListItem_VoidTask_Mutation($input: TaskActionInput!) {
          taskAction(input: $input) {
            task {
              completed
              voided
              history {
                name
                action
                timestamp
              }
              trip {
                id
                welcomeHome
              }
            }
          }
        }
      `,
      variables: { input: { taskId, action: "void", value: true } },
      onError: err => alert(err)
    });
  };

  render() {
    const {
      task: { description, completed, dueDate, voided, voidDate, history }
    } = this.props;

    return (
      <li className={css(styles.taskListItem)}>
        <Checkbox
          className={css(styles.checkbox)}
          labelStyle={voided ? { textDecoration: "line-through" } : null}
          label={description}
          labelPosition="right"
          checked={completed}
          disabled={completed || voided}
          onCheck={this.completeTask}
        />
        {completed || voided ? null : (
          <FlatButton
            label="void"
            disabled={completed || voided}
            secondary={true}
            onTouchTap={this.voidTask}
          />
        )}
      </li>
    );
  }
}

const styles = StyleSheet.create({
  taskListItem: {
    display: "flex",
    marginBottom: 5,
    ":nth-child(even)": {
      background: OurismanTravelTheme.palette.primary3Color
    }
  },
  checkbox: {
    paddingTop: 5
  }
});



// WEBPACK FOOTER //
// /src/components/Trips/TaskListItem.js